export function getCSRFToken() {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'csrftoken') {
      return value;
    }
  }
  return null;
}

// Function to ensure CSRF token is available (optional - for cases where you need to fetch it)
export async function ensureCSRFToken() {
  const token = getCSRFToken();
  if (token) {
    return token;
  }
  
  try {
    const response = await fetch('/api/csrf-token/', {
      method: 'GET',
      credentials: 'include',
    });
    
    if (response.ok) {
      const data = await response.json();
      return data.csrfToken;
    }
  } catch (error) {
    console.error('Failed to get CSRF token:', error);
  }
  
  return null;
}

// Initialize CSRF token on app start (optional)
// export async function initCSRF() {
//   // For most cases, the cookie-based approach above is sufficient
//   // This is only needed if you want to pre-fetch the token
//   await ensureCSRFToken();
// }
